import React from 'react'

class LoanSummaryReviewText extends React.Component {
  render() {
    const {
      role,
      loanSummaryReviewed,
      conditional
    } = this.props

    if (role !== 'primary' && !loanSummaryReviewed && !conditional) {
      return (
        <div className='custom-control custom-checkbox mb-5'>
          <label>
            <span className='grey'>Please review the Loan Setup page to submit the application</span>
          </label>
        </div>
      )
    } else {
      return null
    }
  }
}

export default LoanSummaryReviewText
